import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import styles from './AccessDenied.module.css';

const AccessDenied = ({ message }) => {
  return (
    <div className={styles.accessDeniedContainer}>
      <div className={styles.accessDeniedContent}>
        <FontAwesomeIcon 
          icon={faExclamationTriangle} 
          className={styles.accessDeniedIcon} 
        />
        <h1>Åtkomst nekad</h1>
        <p>{message || 'Du har inte behörighet att komma åt denna sida.'}</p>
        <Link to="/dashboard" className={styles.backButton}>
          Tillbaka till startsidan
        </Link>
      </div>
    </div>
  );
};

AccessDenied.propTypes = {
  message: PropTypes.string,
};

export default AccessDenied; 